"use client";
import BreadCrumb from "@/app/components/lib/breadcrumb/BreadCrumb";
import CategoryDetailsBlackBox from "@/app/components/pages-components/category-page/CategoryDetailsBlackBox";
import { useGetAllCategoriesQuery } from "@/api/AppApi/services/category";
import { useTranslation } from "@/hooks/localization/useTranslations";

type TProps = {
  searchParams: { [key: string]: string };
  loader: React.ReactElement;
};

const Categories: React.FC<TProps> = ({ searchParams, loader }) => {
  const t = useTranslation();

  const { data: allCategoriesData, isLoading: isCategoriesLoading } =
    useGetAllCategoriesQuery({
      enabled: true,
    });

  const subcategories = allCategoriesData?.result;

  return (
    <>
      <article className="category-page">
        {isCategoriesLoading ? (
          loader
        ) : (
          <>
            <BreadCrumb
              // noHome
              hideCrumbBack
              hierarchy={[
                {
                  text: t.all_products,
                },
              ]}
            />
            <h1 className="category-page-title">{t.all_products}</h1>
            <CategoryDetailsBlackBox
              subcategories={subcategories!}
              searchParams={searchParams}
              PixeListName={t.all_products}
            />
          </>
        )}
      </article>
    </>
  );
};

export default Categories;
